export default __webpack_public_path__ + "static/media/up-arrow_header.537a6264.svg";